import type { EditableTextProps } from '../EditableText';

type Placeholder = NonNullable<EditableTextProps['placeholder']>;
type CharacterLimit = NonNullable<EditableTextProps['characterLimit']>;

export function truncatePlaceholderText(text: Placeholder, limit: CharacterLimit) {
    return text.length > limit ? `${text.slice(0, limit)}…` : text;
}
